import { gql } from '@apollo/client';

export const GET_PL_WITH_TRANSACTIONS = gql`
  query getPaymentLinkFilteredList($search: PaymentLinkSearchInput, $limit: Int = 1) {
    getPaymentLinkFilteredList(search: $search, limit: $limit) {
      id
      name
      link
      status
      description
      eventUrl
      startAt
      eventStartAt
      eventEndAt
      amount
      limit
      expiredAt
      notes
      redirectUrl
      createdAt
      formId
      category
      receiver
      reason
      usage
      subType
      target
      qurbanType
      type
      qty
      fundraisingSettings
      urlParamTracking
      affiliateCommission
      affiliateCommissionType
      form {
        fieldObject
        id
        name
      }
      coverImage {
        id
        url
      }
      multipleImage {
        id
        url
        updatedAt
      }
      multipleVideo {
        value
        updatedAt
        id
      }
    }
  }
`;
